import Ganapati from '../assests/ganpathi.jpg'
import Shiva from '../assests/shiva.jpeg'
import Lakshmi from '../assests/lakshmiDevi.jpeg'
import saibaba from '../assests/saibaba.jpeg'
import Hanuma from '../assests/Hanuma.jpg'
import Venkateshwara from '../assests/Venkateswara.jpg'
import Krishana from '../assests/Krishana.jpeg'
import Dhuraga from '../assests/durga.jpeg'
import Surya from '../assests/surya.jpeg'
import Narshima from '../assests/Narashima.jpeg'


export const content = [
   {
      name: 'Load Ganapati',
      URL: Ganapati,
      key: 'Lord Vinayaka'
   },
   {
      name: 'Load Shiva',
      URL: Shiva,
      key: 'Lord Shiva'
   },
   {
      name: 'Load Lakshmi',
      URL: Lakshmi,
      key: 'Goddess Durga'
   },
   {
      name: 'Load Saibaba',
      URL: saibaba,
      key: 'Lord SaiBaba'
   },
   {
      name: 'Load Hanuma',
      URL: Hanuma,
      key: 'Lord Hanuman'
   },
   {
      name: 'Load Venkateshwara',
      URL: Venkateshwara,
      key: 'Lord Venkateswara'
   },
   {
      name: 'Load Krishna',
      URL: Krishana,
      key: 'Lord Surya'
   },
   {
      name: 'Load Dhurga',
      URL: Dhuraga,
      key: 'Lord Surya'
   },
   {
      name: 'Load Surya',
      URL: Surya,
      key: 'Lord Surya'
   },
   {
      name: 'Load Narashima',
      URL: Narshima,
      key: 'Lord Surya'
   },

]